// jshint strict:false, undef:false, unused:false, newcap: false

/*/
	Cremastrap BS4 Base Init
	Stephen Ginn at Crema Design Studio
	Updated 2021-03-22
/*/


/*/
================================================================================
	Data Masking
================================================================================
/*/

S("[inputmode=numeric]").forEach(el => {
	if (el.classList.contains("date")) {
		IMask(el, {mask: '00/00/0000'});
	} else {
		IMask(el, {mask: Number});
	}
});

S("[type=tel]").forEach(el => {
	IMask(el, {mask: '(000) 000-0000'});
});

S(".date").forEach(el => {
	IMask(el, {
		mask: '00/00/0000'
	});
});

S("[autocomplete=cc-number]").forEach(el => {
	IMask(el, {mask: '0000-0000-0000-0000'});

	el.addEventListener("keyup", e => {
		var cardType = detectCardType(el.value.replace(/-/g, ''));

		S(".credit-cards .icon").forEach(icon => {
			icon.classList.add("inactive");

			if (icon.getAttribute("data-type") === cardType) {
				icon.classList.remove("inactive");
			}
		});
	});
});

S("[autocomplete=cc-exp]").forEach(el => {
	IMask(el, {
		mask: '00/0000',
		overwrite: false,
		lazy: false
	});
});

S("[name=ssn]").forEach(el => {
	IMask(el, {mask: '000-00-0000'});
});


/*/
================================================================================
	Miscellaneous
================================================================================
/*/

autofocus(".fields-height");
toggle('[data-toggle=show], [data-toggle=hide]');
addPlanClickEvents();
checkgroups();
new NavigationLock("#modal-navigation-disabled");


/*/
================================================================================
	Contact Forms
================================================================================
/*/

// Initialize Crema Captcha v4.3.8
captcha('[data-captcha]', {
	action: "https://formcarry.com/s/Eluju445J_b"
});

// Initialize Form Fetcher v1.0.0
contact({
	success() {
		this.alert.innerHTML = this.msg;
		this.alert.className = "alert alert-success";
	},
	error() {
		this.alert.innerHTML = this.msg;
		this.alert.className = "alert alert-danger";
	}
});


/*/
================================================================================
	IFE Enrollment Proofing
================================================================================
/*/

// Submit Quote Box
S(".quote-box form").forEach(form => {
	form.addEventListener("submit", e => {
		e.preventDefault();
		enrollment.member = serializeJSON(form);

		getCityState(enrollment.member.zip).then(locale => {
			enrollment.member.city = locale.city;
			enrollment.member.state = locale.state;
			saveData(enrollment);
			refreshDOM();
			form.submit();
		});
	});
});

// Format Nav Action Buttons
S(".nav-actions .btn-back").forEach(el => {
	if (el.nodeName === "BUTTON") {
		el.setAttribute('onclick', 'window.history.back();');
	}
});

S(".nav-actions .btn-continue").forEach(el => {
	el.insertAdjacentHTML('beforeend', '<i class="fa fa-arrow-right ml-1"></i>');

	if (location.pathname === '/dependents') {
		el.classList.add("disabled");
		el.disabled = true;
	}

	if (location.pathname === '/billing') {
		el.innerHTML = '<i class="fa fa-credit-card"></i> Confirm Purchase';
		el.className = 'btn-continue border-warning bg-warning text-dark';
	}
});


/*/
================================================================================
	jQuery Based Init
================================================================================
/*/

// Initialize Tooltips and popovers
$('[data-toggle="tooltip"],[data-hover="tooltip"]').tooltip();
$('[data-toggle="popover"],[data-hover="popover"]').popover({
	trigger: "focus",
	container: "body"
});

$('[data-toggle="popover"],[data-hover="popover"]').attr("tabindex", 0);

// Dynamically Load Bootstrap Modals
/*/
$('.modal').on('show.bs.modal', function (e) {
	var modal = e.target,
		type = modal.id.replace('modal-', ''),
		btn = e.relatedTarget,
		form = btn.closest('form'),
		plan = JSON.parse(sessionStorage.getItem("plan"));

	console.log(btn);
});
/*/

$('.modal').on('show.bs.modal', function (e) {
	var modal = e.target,
		type = modal.id.replace('modal-', ''),
		btn = e.relatedTarget,
		form = btn.closest('form'),
		plan = JSON.parse(sessionStorage.getItem("plan"));

	switch(type) {
		case 'member-contact':
			loadForms();
		break;
		case 'dependent-edit':
			// Push member to dependents
			enrollment.dependents.push(enrollment.member);

			// Get Current Dependent from Parent and Load into Modal
			var id = btn.closest('.dependent').getAttribute("data-id"),
				dependent = enrollment.dependents.filter(x => x.id === id)[0];

			loadDependentForm(modal.querySelector('form'), dependent);
			modal.querySelector(".dependents").innerHTML = getProductCheckboxes(enrollment);

			// Save current dependent to session storage
			sessionStorage.setItem("dependent", JSON.stringify(dependent));
		break;
		case 'details':
			console.log(plan);

			fetch("/details?id=" + plan.id).then(response => response.text()).then(string => {
				modal.querySelector(".modal-title").textContent = plan.title;
				modal.querySelector(".modal-body").innerHTML = string;
			});
		break;
		case 'add-cart':
			if (enrollment.plans.some(e => e.type === plan.type)) {
				var html = `<p class="lead">We could not add this ${plan.type} product to your cart, since another ${plan.type} product is already in it.</p>

				<h4>Your Cart</h4>
				<div class="card card-body">
					<div class="details">
						<h5>${plan.title}</h5>

						Coverage: Family
						<span class="btn btn-outline-secondary badge">Primary</span>
						<span class="btn btn-outline-secondary badge">Spouse</span>
						<br />
						<strong>$XX.00</strong>
					</div>

					<hr />

					<p>Would you like to replace the plan in your cart with this new plan?</p>

					<div class="btn-group align-self-start">
						<a class="btn btn-outline-primary" data-dismiss="modal">Yes</a>
						<a class="btn btn-outline-primary" data-dismiss="modal">No</a>
					</div>
				</div>`;

				modal.querySelector(".modal-title").textContent = "Product was not added";
				modal.querySelector(".plan-added").classList.add("d-none");
				modal.querySelector(".plan-not-added").classList.remove("d-none");
				modal.querySelector(".plan-not-added").innerHTML = html;
			} else {
				modal.querySelector(".modal-title").textContent = "Added Plan to Cart";
				modal.querySelector(".plan-not-added").classList.add("d-none");
				modal.querySelector(".plan-added").classList.remove("d-none");
				modal.querySelector(".plan-not-added").innerHTML = '';

				enrollment.plans.push(plan);
				saveData(enrollment);
				updateCart();
				refreshDOM(this, plan);
			}

			// Hide current plan type in cart modal
			var el = modal.querySelector(".type-" + plan.type);

			if (el) {
				el.classList.add("d-none");
			} else {
				console.error(plan.type + " plan type not found in add-cart modal");
			}
		break;
		case 'edit-plan':
			modal.querySelector(".modal-title").textContent = plan.title;
			modal.querySelector(".monthly-cost").textContent = plan.price.money();

			// Reflect the plan's saved coverage selections in the dropdowns
			var saved = enrollment.plans.find(p => p.id === plan.id) || plan;
			var covType = modal.querySelector('[name="coverage"]');
			var covWho = modal.querySelector('[name="covered"]');
			if (covType && saved.coverageType) covType.value = saved.coverageType;
			if (covWho && saved.coverage && saved.coverage.length) covWho.value = saved.coverage[0];
		break;
		case 'dependent-create':
			productCheckboxes = getProductCheckboxes(enrollment);
			modal.querySelector(".modal-body .dependents").innerHTML = productCheckboxes;
		break;
		case 'med-agreement':
		case 'med-release':
			var checkbox = document.querySelector(`[name=${modal.id.replace(/modal-/i, '')}]`);

			btn.classList.remove('btn-outline-danger');
			btn.classList.add('btn-outline-primary');
			checkbox.closest('label').classList.remove('disabled');
		break;
	}
});

// Certain modals need to be triggered LATER, so that btn-group classes can be toggled correctly
$('.modal').on('shown.bs.modal', function (e) {
	var modal = e.target,
		type = modal.id.replace('modal-', ''),
		btn = e.relatedTarget;

	switch(type) {
		case 'occupations':
		case 'medications':
		case 'conditions':
			btn.classList.remove('btn-outline-danger', 'active');
			btn.classList.add('btn-outline-secondary');

			S(btn.getAttribute('data-next') + ' .btn').forEach(btn => {
				btn.classList.remove('disabled');
			});
		break;
	}
});

$('.modal').on('hide.bs.modal', function (e) {
	var modal = e.target,
		type = modal.id.replace('modal-', ''),
		btn = e.relatedTarget;

	switch(type) {
		case 'knockout':
			document.forms.questions.submit();
		break;
	}
});


/*/
================================================================================
	Remove Plan from Cart (Edit Plan Modal)
================================================================================
/*/

S("#modal-edit-plan .btn-delete-plan").forEach(btn => {
	btn.addEventListener("click", e => {
		e.preventDefault();

		// Remove the selected plan, persist, then re-render the cart
		var plan = JSON.parse(sessionStorage.getItem("plan"));
		enrollment.plans = enrollment.plans.filter(p => p.id !== plan.id);

		saveData(enrollment).then(() => location.reload());
	});
});

// Save coverage changes from the Edit Plan modal back to the cart item
S("#modal-edit-plan .btn-save").forEach(btn => {
	btn.addEventListener("click", e => {
		var stored = JSON.parse(sessionStorage.getItem("plan")),
			modal = btn.closest(".modal"),
			item = enrollment.plans.find(p => p.id === stored.id);

		if (! item) return;

		item.coverageType = modal.querySelector('[name="coverage"]').value;
		item.coverage = [modal.querySelector('[name="covered"]').value];

		saveData(enrollment).then(() => location.reload());
	});
});


// Billing Page
/*/
$('[data-toggle="tab"]').on('shown.bs.tab', function (e) {
	$(e.target).siblings().button('toggle');
	$(e.target).button('toggle');
});
/*/


/*/
================================================================================
	Navbar Scroll Effect
================================================================================
/*/

window.addEventListener('scroll', function() {
	const navbar = document.querySelector('.navbar-desktop');
	if (!navbar) return;
	
	if (window.scrollY > 50) {
		navbar.classList.add('scrolled');
	} else {
		navbar.classList.remove('scrolled');
	}
});
